// extracted by mini-css-extract-plugin
module.exports = {"root":"Backdrop_root__37JwA","App":"Backdrop_App__2ulAp","User":"Backdrop_User__1axVI","Inbox":"Backdrop_Inbox__1RdAF","Backdrop":"Backdrop_Backdrop__1uOgA"};